import React from 'react'
import { Breadcrumbs, Typography } from '@mui/material'
import NextLink from '@imports/NextLink'

export default function ItemTrace({ icon = '/', items }) {
  return (
    <Breadcrumbs
      separator={icon}
      aria-label="breadcrumb"
    >
      {items.map(({ text, url }, index) =>
        url ? (
          <NextLink
            key={index}
            color="inherit"
            href={url}
            style={{ fontSize: '16px', textTransform: 'capitalize' }}
          >
            {text}
          </NextLink>
        ) : (
          <Typography
            key={index}
            color="#000"
            variant="caption"
            textTransform="capitalize"
          >
            {text}
          </Typography>
        )
      )}
    </Breadcrumbs>
  )
}
